import type { UnlockMessageId } from "../../content/types";

export const UNLOCK_MESSAGES: Readonly<Record<UnlockMessageId, string>> = {
  "secret-and-survival":
    "CONGRATULATIONS!\nMission X unlocked!\nSurvival mode unlocked!",
  ultimate: "CONGRATULATIONS!\nYou are the ultimate Xenos warrior.",
  welcome: "Welcome to Xenos.\nYour progress is auto-saved.",
};
